export default __webpack_public_path__ + "static/qrm-presentation-0f05481ca0da45e908fad5d6616e4efb.png";